import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { LanguagesTypes } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-tooltip',
  templateUrl: './bmcore-tooltip.component.html',
  styleUrls: ['./bmcore-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTooltipComponent implements OnInit {
  @Input() lang: LanguagesTypes

  isTooltipOpen = false

  constructor() {}

  ngOnInit(): void {}

  tooltipHandler() {
    this.isTooltipOpen = !this.isTooltipOpen
  }
}
